export const Role = {
    ADMIN: 1,
    WORKER: 2,
    AGENT: 3,
};